const firebaseConfig = {
    apiKey: "AIzaSyDNYF9Xpe-A8DlVLreGGgNM8LCgIAxIT6Y",
    authDomain: "eat-cake-shop.firebaseapp.com",
    projectId: "eat-cake-shop",
    storageBucket: "eat-cake-shop.appspot.com",
    messagingSenderId: "928014559909",
    appId: "1:928014559909:web:155f00c860a996686a3b4c"
};

export default firebaseConfig;